// import { backendAPI } from "../../api";

export const memberLoadStartedHOL = (bool) => ({
  type: "MEM_HOL_LOAD_START",
  isloading: bool,
})

export const memberLoadedHOL = (member) => ({
  type: "LOADED_HOL_MEMBER",
  member,
})

export const memberLoadHOLError = (error) => ({
  type: "MEM_HOL_LOAD_ERROR",
  error: error,
})
